import { STORE_FOOD_COURTS_LIST } from '../actions';

export default function foodCourtsList(state = [], action) {
    switch (action.type) {
      case STORE_FOOD_COURTS_LIST:
        return action.payload;
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/store/reducers/foodCourtsList.js